export enum GooglePlacesAutocompleteRequestType {
  Geocode = 'geocode',
  Address = 'address',
  Establishment = 'establishment',
}
